import PrivateRoutesConfig from "../config/PrivateRoutesConfig";


export default function GetHeaderFromPath(path) {

    let routes = PrivateRoutesConfig;
    var title;
    var route = routes
        .filter(route => path.includes(('/' + route.path)));

    if (route == null || (route.length === 0 && path === '/')) {
        title = 'Home';
    } else {
        title = route[0].title;
    }

    return title;
}